const prefix = 'WATCH_TOWER/';

export const WATCH_TOWER_COMPANIES_TAG = `${prefix}COMPANIES`;
export const WATCH_TOWER_COMPANY_TAG = `${prefix}COMPANY`;
export const WATCH_TOWER_TOPICS_TAG = `${prefix}TOPICS`;
export const WATCH_TOWER_SCHEDULES_TAG = `${prefix}SCHEDULES`;
export const WATCH_TOWER_INCIDENTS_TAG = `${prefix}INCIDENTS`;
export const WATCH_TOWER_INCIDENT_TAG = `${prefix}INCIDENT`;
export const WATCH_TOWER_RUNS_TAG = `${prefix}RUNS`;
export const WATCH_TOWER_CHATS_TAG = `${prefix}CHATS`;
